import { PropsWithChildren } from 'react';

import AppShell from '@/components/app-shell/AppShell';
import { useAppShell } from '@/data/context/AppShellContext';
import useShellScrollRestoration from '@/data/hook/app-shell/useShellScrollRestoration';
import { isStudent } from '@/functions/auth';

export default function ShellContent({ children }: PropsWithChildren) {
  const { user } = useAppShell();
  const mainRef = useShellScrollRestoration<HTMLElement>();

  return (
    <AppShell.Content
      ref={mainRef}
      className={isStudent(user.userType) ? undefined : 'bg-base-200'}
    >
      {children}
    </AppShell.Content>
  );
}
